import { render, staticRenderFns } from "./ViewConfigurationDialog.vue?vue&type=template&id=d6954c6e&lang=pug&"
import script from "./ViewConfigurationDialog.vue?vue&type=script&lang=js&"
export * from "./ViewConfigurationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ViewConfigurationDialog.vue"
export default component.exports